import { render } from "./App.vue?vue&type=template&id=7b7d2aa1"
const script = {}

import "./App.vue?vue&type=style&index=0&id=7b7d2aa1&lang=css"

import exportComponent from "/home/flow/draceo/clients/interne/projets/glitch-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__